import { render } from "./recordList.vue?vue&type=template&id=e19daae6&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"

import "./recordList.vue?vue&type=style&index=0&id=e19daae6&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19daae6"],['__file',"src/views/widget/questionRegForm/recordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e19daae6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e19daae6', __exports__)) {
    console.log('reload')
    api.reload('e19daae6', __exports__)
  }
  
  module.hot.accept("./recordList.vue?vue&type=template&id=e19daae6&scoped=true", () => {
    console.log('re-render')
    api.rerender('e19daae6', render)
  })

}


export default __exports__